export { normalizeSnapPoints } from './normalizeSnapPoints';
